import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { AppTokenHandler } from '../Common/app-token-handler';
import { Location } from '@angular/common';
//import { StartupPopupComponent } from '../out-of-application/startup-popup/startup-popup.component';
//import { MatDialog } from '@angular/material';
//import { Global } from '../Global';
import { CommonService } from '../shared/common.service';
import { environment } from '../../environments/environment';
import { DataService } from '../Common/data.service';
import { AppInsightsService } from './app-insights.service';
import { catchError, Subject, takeUntil, throwError } from 'rxjs';
import { AzureADAuthService } from './azure-adauth.service';
import { LoginService } from './login.service';
@Injectable()
export class AuthGuardService {
  isRole = false;
  userDetails: any;
  roleList: string[];
  href: string;
  private _destroying$ = new Subject<void>();
  private azure_token: string = '';
  isInRole: any;
  constructor(private router: Router, private appToken: AppTokenHandler, private appInsightsService: AppInsightsService,
    private authADService: AzureADAuthService, private loginService: LoginService,
    // private dddd: MatDialog,  private _global: Global,
    private location: Location, private _common: DataService) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.LogPageAnalytics();
      }
    });
  }
  // canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  //   const expectedRole = next.data.expectedRole;
  //   if (this.appToken.getLoginUserInfo() == null) {
  //     this.href = this.location.path();
  //     this._common.GetUserDetails(this.href, expectedRole);
  //     // this.router.navigate(['/login']);
  //   } else {
  //     this.userDetails = this.appToken.getLoginUserInfo();
  //     if (this.userDetails === null) {
  //       this.isRole = false;
  //     } else {
  //       this.isRole = false;
  //       this.roleList = this.userDetails.Roles.split(',');
  //       expectedRole.forEach(element => {
  //         if (this.roleList.indexOf(element) >= 0) {
  //           this.isRole = true;
  //         }
  //       });
  //     }
  //     if (!this.isRole) {
  //       this.router.navigate(['/error/4']);
  //       return false;
  //     } else {

  //       return true;
  //     }
  //   }
  // }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.loginService.redirectUrl = state.url;
    // this.loginService.redirectUrl = this.location.path();
    const expectedRoles = next.data['expectedRole'];
    const isUserLoggedIn = this.appToken.isLoggedIn;

    if (!isUserLoggedIn) {
      sessionStorage.setItem('redirectUrl', state.url);
      this.router.navigate(['/']);
      return false;
    } else {
      this.isInRole = this.appToken.IsInRole(expectedRoles);
      if (!this.isInRole) {
        this.router.navigate(['/error/4']);
        return false;
      } else {
        return true;
      }
    }
  }

  LogPageAnalytics() {
    // if (environment.logPageAnalytics === 'Y') {
    //     this._common.LogPageAnalytics(
    //         // tslint:disable-next-line:max-line-length
    //         environment.pageAnalyticsUrl + '?PageTitle=' + window.location.href.replace('#/', '') + '&ApplicationCode=' + environment.appcode
    //     ).subscribe(data => {
    //         // console.log('logpageanalytics::success: ', data);
    //     }, (error) => {
    //         // console.log('logpageanalytics: ', error);
    //     });
    // }

    let IsLogAppInsights = false;
    let UserInfo = this.appToken.getLoginUserInfo();

    if (UserInfo != null && UserInfo.IsLogAppInsights != null) {
      IsLogAppInsights = UserInfo.IsLogAppInsights;
    }
    if (IsLogAppInsights) {
      const username = UserInfo.EmpGPN; // Replace with actual username retrieval logic
      this.appInsightsService.trackPageView(window.location.href.replace('#/', ''), username);
    }
  }

  async acquireAzureToken(): Promise<void> {
    try {
      const result = await this.authADService.handleQueryParameters()
        .pipe(
          takeUntil(this._destroying$),
          catchError(error => {
            return throwError(() => error);
          })
        ).toPromise();

      if (result) {
        this.azure_token = result;
        // this.GetUserDetails(); // Uncomment when needed
      }
    } catch (error) {
      // Handle error (optional)
      console.error('Error acquiring Azure token:', error);
      throw error; // Or handle the error in another way
    }
  }


}
